<template>
  <div>
    <assay-status-badge
      v-if="valueIsDefined"
      :status="value"
    />
  </div>
</template>

<script>

import Vue from 'vue'

import AssayStatusBadge from '@/modules/laboratoryModule/AssayStatusBadge'

export default Vue.extend({
    name: 'AssayStatusRenderer',
    components: {
        AssayStatusBadge
    },
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        },
        value() {
            if (this.params.isFilterCellRenderer) {
                return this.params.states.find((state) => state.code === this.params.value)
            }
            return this.params.value
        }
    }
})

</script>
